export default (app, store) => {
    return {
        getFontesDeDados() {
            if (store.getters.painel.dadosPainel == undefined || store.getters.painel.dadosPainel.fontesDados == undefined)
                return null;

            let fonteDados = store.getters.painel.dadosPainel.fontesDados.map(f => {
                return {
                    idUnico: f.idUnico,
                    desc: f.alias,
                    campos: f.campos,
                    aux: undefined //para utilização livre em componentes //nao mexer, isso é utilizado!!
                }
            }).sort((a, b) => {
                //Ordena as fontes de dados por sua descrição
                if((a.alias || a.desc) > (b.alias || b.desc)) return 1;
                if((a.alias || a.desc) < (b.alias || b.desc)) return -1;
                return 0;
            });

            return fonteDados;
        },

        getFonteDeDados(idUnico) {
            if (store.getters.painel.dadosPainel == undefined || store.getters.painel.dadosPainel.fontesDados == undefined)
                return null;

            return store.getters.painel.dadosPainel.fontesDados.find(f => f.idUnico == idUnico);
        },

        /**
         * Varre o texto em busca de variáveis de usuário
         * Verifica se o valor da variável já está em memória e reutiliza para não fazer requisições repetidas
         * Faz um "lock" na busca pra não ter várias requisições pra mesma variável
         */
        async replaceVariaveisUsuario(texto) {
            if (texto) {
                let variaveis = texto.match(/\[(\d*)\|[^\[]*\]/gimu)
                if (variaveis) {
                    await app.config.globalProperties.$vistra.Objetos.when2(
                        {
                            condition: () => !store.getters.painel.buscandoValorVariavelusuario,
                            callback: async () => {
                                // let req = "!@#$ " + Math.random().toString().slice(2, 5)
                                store.dispatch("setBuscandoValorVariavelusuario", true)
                                for (let variavel of variaveis) {
                                    let idVariavel = variavel.match(/\[(\d*)\|[^\[]*\]/)[1]
                                    let valorVariavel = store.getters.painel.valoresVariaveis.find(v => v.id === idVariavel)
                                    if (!valorVariavel) {
                                        // console.show(req, " - 1 - Buscando valor de variável de usuário", variavel)
                                        let valorBanco = (await app.config.globalProperties.$http.get("/VariavelUsuario/GetValorVariavel/"+ idVariavel)).data
                                        valorVariavel = {
                                            id: idVariavel,
                                            valor: valorBanco
                                        }
                                        store.dispatch("addValorVariavelUsuario", valorVariavel)
                                    } else {
                                        // console.show(req, " - 2 - Reaproveitou valor de variável de usuário", variavel)
                                    }
                                    texto = texto.split(variavel).join(valorVariavel.valor)
                                }
                                store.dispatch("setBuscandoValorVariavelusuario", false)
                            },
                            interval: 2
                        }
                    )
                }
            }
            return texto            
        }

    }
}